import { Box, Flex } from '@chakra-ui/react';
import { FC } from 'react';

interface ImageViewerProps {
  url: string;
  filename: string;
}

export const ImageViewer: FC<ImageViewerProps> = ({ url, filename }) => (
  <Flex flex={1} align="center" justify="center" overflow="auto" p={4}>
    <Box
      as="img"
      src={url}
      alt={filename}
      maxWidth="100%"
      maxHeight="100%"
      objectFit="contain"
    />
  </Flex>
);

ImageViewer.displayName = 'ImageViewer';
